export const themes = {
  default: {
    thRoot: 'bg-white p-3',
    thHeader: 'border-b-1 border-gray-light mb-3 pb-2',
    thPriceTheme: 'package',
    thNoPriceLabel: 'font-bold font-sans my-4 text-center text-base text-gray-darker',
    thLabel: 'font-bold font-sans mb-0 mt-2 text-center text-gray-darker text-md',
    thIconsList: 'list-none p-0 flex flex-wrap items-center my-3 text-gray-medium',
    thIconsListItem: 'w-1/4 text-center',
    thIconWidth: '1.625rem',
    thInfosList: 'list-none p-0 font-sans my-1 text-gray-darker text-base',
    thInfosListItem: 'list-disc',
    thButton: 'mt-3 w-full',
  },
};
